import React, { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

const OrderByBar = ({ selectConfig, selectedOptionSessionStorageKey }) => {
  const [optionSortedBy, setSortedBy] = useState("");

  const handleOptionSelection = selectedValue => {
    setSortedBy(selectedValue);
    const selectedOption = selectConfig.find(
      option => option.value === selectedValue
    );
    selectedOption.action();
    if (selectedOptionSessionStorageKey) {
      sessionStorage.setItem(
        selectedOptionSessionStorageKey,
        selectedOption.value
      );
    }
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <Menu
      as="div"
      className="tw-relative tw-inline-block sm:tw-pl-2 tw-text-left"
    >
      <Menu.Button className="tw-flex tw-justify-center tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-p-2 tw-bg-white tw-text-sm tw-text-gray-700 ">
        {optionSortedBy.length > 1 ? (
          <div className="tw-flex tw-w-max">{optionSortedBy}</div>
        ) : (
          "Sort"
        )}
        <ChevronDownIcon
          className="tw--mr-1 tw-ml-2 tw-h-5 tw-w-5"
          aria-hidden="true"
        />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="tw-transition tw-ease-out tw-duration-100"
        enterFrom="tw-transform tw-opacity-0 tw-scale-95"
        enterTo="tw-transform tw-opacity-100 tw-scale-100"
        leave="tw-transition tw-ease-in tw-duration-75"
        leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
        leaveTo="tw-transform tw-opacity-0 tw-scale-95"
      >
        <Menu.Items className="tw-origin-top-right tw-absolute tw-right-0 tw-mt-2 tw-w-36 tw-rounded-md tw-shadow-lg tw-bg-white tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-focus:outline-none">
          <div className="tw-py-1">
            {selectConfig.map(option => (
              <Menu.Item key={option.value}>
                {({ active }) => (
                  <div
                    onClick={() => handleOptionSelection(option.value)}
                    href="#"
                    className={classNames(
                      active
                        ? "tw-bg-gray-100 tw-text-gray-900 tw-no-underline"
                        : "tw-no-underline tw-text-gray-700",
                      "tw-block tw-px-4 tw-py-2 tw-text-sm tw-no-underline tw-cursor-pointer "
                    )}
                  >
                    {option.value}
                  </div>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default OrderByBar;
